import { NgModule } from '@angular/core';
import {
  HashLocationStrategy,
  LocationStrategy,
  PathLocationStrategy,
} from '@angular/common';
import { registerLocaleData } from '@angular/common';
import localeTr from '@angular/common/locales/tr';
import localeEs from '@angular/common/locales/es';
import localeDe from '@angular/common/locales/de';
import localeEl from '@angular/common/locales/el';
import { BrowserModule, Title } from '@angular/platform-browser';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http'; // Import HttpClientModule
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ReactiveFormsModule } from '@angular/forms';
import { LoginComponent } from './login/login.component';
import { RegisterComponent } from './views/pages/register/register.component';
import { FormsModule } from '@angular/forms'; // Import FormsModule here
import { FullCalendarModule } from '@fullcalendar/angular';
import { NgScrollbarModule } from 'ngx-scrollbar';
import { HttpClient } from '@angular/common/http';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { DragDropModule } from '@angular/cdk/drag-drop';
// AoT requires an exported function for factories
export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http);
}
import { NgxAnimatedCounterModule } from '@bugsplat/ngx-animated-counter';
import { DdmmyyyyPipe } from './pipes/ddmmyyyy.pipe';
import { ToastrModule } from 'ngx-toastr';

// Import routing module
import { AppRoutingModule } from './app-routing.module';

// Import app component
import { AppComponent } from './app.component';
import { AuthInterceptor } from './auth.interceptor';
import { NativeBackDirective } from './directives/native-back.directive';

import { ForgotPasswordComponent } from './login/forgot-password/forgot-password.component';
import { OnboardingFinalizeComponent } from './onboarding/onboarding-finalize/onboarding-finalize.component';
import { OtaUpdateModalComponent } from './components/ota-update-modal/ota-update-modal.component';
import { CommonModule } from '@angular/common';

// Import containers
import {
  DefaultFooterComponent,
  DefaultHeaderComponent,
  DefaultLayoutComponent,
  MobileNavComponent,
  AssistantOverlayComponent,
} from './containers';
import { BusinessHopperComponent } from './containers/default-layout/business-hopper/business-hopper.component';
import { LogoContrastDirective } from './components/business-logo/logo-contrast.directive';

import {
  AvatarModule,
  BadgeModule,
  BreadcrumbModule,
  ButtonGroupModule,
  ButtonModule,
  CardModule,
  DropdownModule,
  FooterModule,
  FormModule,
  GridModule,
  HeaderModule,
  ListGroupModule,
  NavModule,
  ProgressModule,
  SharedModule,
  SidebarModule,
  TabsModule,
  UtilitiesModule,
  AlertModule,
  ModalModule,
  PopoverModule,
  ToastModule,
  TooltipModule,
  
} from '@coreui/angular-pro';



import { IconModule, IconSetService } from '@coreui/icons-angular';

registerLocaleData(localeTr);
registerLocaleData(localeEs);
registerLocaleData(localeDe);
registerLocaleData(localeEl);

const APP_CONTAINERS = [
  DefaultFooterComponent,
  DefaultHeaderComponent,
  DefaultLayoutComponent,
  MobileNavComponent,
  AssistantOverlayComponent,
];

@NgModule({ declarations: [
        AppComponent,
        LoginComponent,
        ForgotPasswordComponent,
        OnboardingFinalizeComponent,
        DdmmyyyyPipe,
        NativeBackDirective,
        ...APP_CONTAINERS
    ],
    bootstrap: [AppComponent], imports: [DragDropModule,
        LogoContrastDirective,
        BrowserModule,
        FormsModule,
        BrowserAnimationsModule,
        AppRoutingModule,
        AvatarModule,
        BreadcrumbModule,
        FooterModule,
        DropdownModule,
        GridModule,
        HeaderModule,
        SidebarModule,
        IconModule,
        NavModule,
        ButtonModule,
        FormModule,
        UtilitiesModule,
        ButtonGroupModule,
        ReactiveFormsModule,
        SidebarModule,
        SharedModule,
        TabsModule,
        ListGroupModule,
        ProgressModule,
        BadgeModule,
        ListGroupModule,
        CardModule,
        NgScrollbarModule,
        AlertModule,
        ModalModule,
        PopoverModule,
        ToastModule,
        TooltipModule,
        FullCalendarModule,
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: HttpLoaderFactory,
                deps: [HttpClient]
            }
        }),
        NgxAnimatedCounterModule,
        ToastrModule.forRoot({
            positionClass: 'toast-bottom-right',
            preventDuplicates: true,
            timeOut: 4000,
        }),
        // OTA güncelleme modalı
        OtaUpdateModalComponent,
        BusinessHopperComponent,
        CommonModule], providers: [
        {
            provide: LocationStrategy,
            useClass: HashLocationStrategy,
        },
        IconSetService,
        Title,
        {
            provide: HTTP_INTERCEPTORS,
            useClass: AuthInterceptor,
            multi: true,
        },
        provideHttpClient(withInterceptorsFromDi()),
    ] })
export class AppModule { }
